import { render, staticRenderFns } from "./ItemInventories.vue?vue&type=template&id=961ca2ea&scoped=true"
import script from "./ItemInventories.vue?vue&type=script&lang=js"
export * from "./ItemInventories.vue?vue&type=script&lang=js"
import style0 from "./ItemInventories.vue?vue&type=style&index=0&id=961ca2ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961ca2ea",
  null
  
)

export default component.exports